import { useCallback } from 'react';

import useRest from '@/helper/hooks/useRest';
import { FetchingStatus } from '@/interfaces';

const useForgotPasswordAPI = () => {
  const [fetchStatus, error, data, execute] = useRest('/api/auth/password/forget');

  const isFetching = fetchStatus === FetchingStatus.Fetching;
  const executeAPI = useCallback(
    (values: any) =>
      execute({
        body: JSON.stringify({
          emailId: values.email,
        }),
      }),
    [execute],
  );

  return { fetching: isFetching, error, data, execute: executeAPI };
};

export default useForgotPasswordAPI;
